<!-- AGENT CUBED-->
@if (isAgentCube) {
  <div class='quick-link'>
    <a href="" (click)="$event.preventDefault(); submitSSOForm();" class="external-link">
      {{ agentCubedLabel || 'AgentCubed' }}
      <span class="material-symbols-outlined">open_in_new</span>
    </a>
  </div>
}